module.exports = __webpack_public_path__ + "img/taas.da1ed60c.svg";